import { Grid } from '@mui/material';
import { DisplayText } from 'components';

const EventDetailsComponent = ({ event }) => {
	return (
		<div>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<DisplayText label={'Event Description:'} text={event.description} />
				</Grid>
				<Grid item xs={4}>
					<DisplayText
						label={'Start Date:'}
						text={
							new Date(event.start_date).toLocaleDateString('en-GB') +
							' ' +
							new Date(event.start_date).toLocaleTimeString()
						}
					/>
				</Grid>
				<Grid item xs={4}>
					<DisplayText
						label={'End Date:'}
						text={
							new Date(event.end_date).toLocaleDateString('en-GB') +
							' ' +
							new Date(event.end_date).toLocaleTimeString()
						}
					/>
				</Grid>

				<Grid item xs={4}>
					<DisplayText label={'Timezone:'} text={event.timezone} />
				</Grid>
				<Grid item xs={4}>
					<DisplayText label={'Academy:'} text={event?.academy?.title} />
				</Grid>
				<Grid item xs={4}>
					<DisplayText
						label={'Published Event:'}
						text={event.published ? 'Yes' : 'No'}
					/>
				</Grid>
			</Grid>
		</div>
	);
};

export default EventDetailsComponent;
